export const qbooksMatchingUrL =
    'https://support.approvalmax.com/portal/en/kb/approvalmax-1/approvalmax-for-quickbooks-online/matching';
export const qbooksMatchingVideoUrl = 'https://youtu.be/nKAXnNhFGpc';
